/** Shrink fixed-column cells to the measured content width, retaining the configured cap. */
export function fittedGridWidth(columns: number, preferred: number, available: number | null, gap: number): number {
  if (!columns || available === null) return preferred;
  return Math.max(1, Math.min(preferred, (available - Math.max(0, columns - 1) * gap) / columns));
}
